<template>
    <v-btn :loading="loadingBtn" :class="[baseClass, { 'PrimaryButton': isPrimary, 'BlackButton': Black }, buttonClass]" :disabled="disabled"
        elevation="0" @click="handleClick" :x-small="xsmall" :small="small"  :value="value" >
        <template v-if="icon">
            <v-icon class="mr-1" style="font-size: 16px;" :color="iconColor">{{ icon }}</v-icon>
        </template>

        {{ buttonText }}

    </v-btn>
</template>

<script>
export default {
    name: 'TextButton',
    props: {

        buttonText: {
            type: String,
            default: 'Save'
        },
        icon: {
            type: String,
            default: ''
        },
        iconColor: {
            type: String,
            default: '#fff'
        },
        Black: {
            type: Boolean,
            default: false
        },
        isPrimary: {
            type: Boolean,
            default: false
        },
        buttonClass: {
            type: String,
            default: 'TextButton'
        },
        buttonClick: {
            type: Function,
        },
        disabled: {
            type: Boolean,
            default: false
        },
        xsmall: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        color: { // 버튼의 배경색을 지정할 prop 추가
            type: String,
            default: '#fff' // 기본값은 흰색
        },
        value: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        baseClass() {
            return this.isPrimary ? 'PrimaryButton' : 'TextButton';
        },
        loadingBtn(){
            return this.loading;
        }
    },
    methods: {
        handleClick() {
            this.$emit('click');
            // this.buttonClick();
        }
    }
};
</script>

<style scoped>
.TextButton {
    background: #fff !important;
    border: 1px solid #bbb;
}

.PrimaryButton {
    background: #007bff !important;
    color: #fff;
}

.BlackButton {
    background: #000 !important;
    color: #fff;
}
</style>